const conf = {
    /**
     * 共用链接
     */
    links: {
        // app下载链接
        downLoad: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.duowan.kiwi',
        universal: ''
    },
    /**
     * 数据上报
     */
    report: {
        'home': '首页',
        'zhibo/gift': '直播间/送礼'
    },
    /**
     * 数据接口地址
     */
    dataUrls: {
        // 首页分类数据接口
        indexTypes: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=InterModal&do=getGameInfo',
        // 首页分类对应直播列表数据接口
        indexTypeLiveData: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=InterModal&do=getLiveListByGamePage',
        // 首页某分类下的所有标签
        indexTypeTags: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=Tag&do=getTagInfo',
        // 首页分类对应直播列表数据接口
        indexTagLiveData: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=LiveList&do=getLiveListByPage',
        // 首页周贡榜数据接口
        indexWeekRankData: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=InterModal&do=getWeekRank',
        // 首页热门推荐
        indexHotRecData: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=Home&do=getHotRecommendModule',
        // 订阅列表接口
        subscribeList: process.env.REACT_APP_HOST_OPEN + '/cache.php?m=InterModalUser&do=getSubscribeList',
        // 直播间信息
        roomInfo: process.env.REACT_APP_HOST_M + '/cache.php?m=WechatpubH5Api&do=ajaxGetLiveData',
        // 订阅
        subscribe: process.env.REACT_APP_HOST_M + '/member/index.php?m=WechatpubH5Api&do=jsonpSubU',
        // 支付相关
        pay: process.env.REACT_APP_HOST_PAY + '/index.php?m=PayGoldbeanWechat',
	    // 支付相关
	    payUn: process.env.REACT_APP_HOST_PAY + '/index.php?m=HuyaPayBean',
        

    },
    gid:{
        xingxiu: 1663,//1663,
        yanzhi: 2168
    },
    /**
     * 共用文案
     */
    tips: {
        // 列表滚动到底部的下载提示文案
        nomore: '到底啦~去虎牙APP，观看更多美女直播~'
    },
    gift: {
        list: [1, 10, 30, 66, 188, 520, 1314],
        des: {
            1314: '一生一世',
            520: '我爱你',
            188: '要抱抱',
            66: '一切顺利',
            30: '想你',
            10: '十全十美',
            1: '一心一意'
        }
    },

    /**
     * 充值套餐定义
     * defautVal 默认套餐
     * base  基准金豆数
     * price 每万金豆价格（元）[ price * list[index] = 实际金额]
     * list  套餐内容 [ 实际金豆数 = base * list[index]]
     */
    topupInfo: {
        defautVal: 1,
        base: 10000,
        price: 12,
        list: [0.1, 1, 5, 30, 100, 200]
    },
    shareInfo:[
        '热舞八卦深情唱，颜值才艺集一身，%s等你来撩-虎牙直播',
        '点开直播间，找回初恋般的感觉~-虎牙直播',
        '更青春 更校园 来与高颜值的灵魂一起Freestyle~-虎牙直播',
        '性感清纯帅气，总有你所爱，一起来撩主播呀~-虎牙直播',
        '颜值有料，上虎牙就够了！-虎牙直播',
        '颜值炸了？女神男神遍地是，抓紧撩吧！-虎牙直播'
    ]
}

export default conf;


// WEBPACK FOOTER //
// ./src/common/js/conf.js